import { PowerBIReportEmbed, type ContinuumReport } from '@equinoxx/react'
import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import MainLayout from '../components/MainLayout'

interface PageReportDetailProps { }
const PageReportDetail = function (props: PageReportDetailProps) {
    const [report, setReport] = React.useState<ContinuumReport | null>(null)
    const { id } = useParams()
    const [searchParams] = useSearchParams()
    const workspaceId = searchParams.get('workspaceId')
    return (
        <MainLayout pageTitle={report ? 'Report: ' + report.name : 'Report'} containerType="fluid">
            {workspaceId ? (
                <PowerBIReportEmbed
                    apiPrefix="continuum-bi/"
                    reportId={id!}
                    workspaceId={workspaceId}
                    onReportLoaded={(report) => setReport(report)}
                />
            ) : (
                <div className="alert alert-warning">No workspace specified.</div>
            )}
        </MainLayout>
    )
}
export { PageReportDetail as default }

